// User-confirmed nonexistent venue; retained here until the reviewed CMS removal ships.
export const EXCLUDED_LISTING = {
  id: 'listing-tuktuktiki-surf-school',
  slug: 'tuktuktiki-surf-school',
  reason: 'TUKTUKTIKI doesnt exist please remove it',
}

export const activeListingFilter = `!(_id in ["${EXCLUDED_LISTING.id}", "drafts.${EXCLUDED_LISTING.id}"]) && coalesce(slug.current, "") != "${EXCLUDED_LISTING.slug}"`

export function isExcludedListing(listing = {}) {
  const id = String(listing._id || '').replace(/^drafts\./, '')
  const slug = typeof listing.slug === 'string' ? listing.slug : listing.slug?.current
  return id === EXCLUDED_LISTING.id || slug === EXCLUDED_LISTING.slug
}

// Preserve Portable Text keys and unrelated copy while the CMS correction awaits review.
export function applyListingExclusionsToPost(post) {
  if (post?._id?.replace(/^drafts\./, '') !== 'blog-beginner-surfing-selong-belanak') return post
  return {
    ...post,
    sections: (post.sections || []).map(section => ({
      ...section,
      content: (section.content || []).map(block => ({
        ...block,
        ...(block.children ? { children: block.children.map(span => ({
          ...span,
          ...(typeof span.text === 'string' ? {
            text: span.text.replace('Mul’s, OlaOla and TUKTUKTIKI.', 'Mul’s and OlaOla.'),
          } : {}),
        })) } : {}),
      })),
    })),
  }
}
